<template>
    <div>
        <form id="documents" enctype="multipart/form-data">
            <div  v-if="is_main_merchant" class="container p-3 pt-5 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('pos.business_documents') }}
                    </div>
                    <kt-row>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="national_card">
                                        {{ $t('pos.document.certificate') }}
                                    </kt-form-label>
                                    <kt-form-label for="certificate_form"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="certificate_form"
                                            name="certificate_form"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.certificate_form"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('certificate_form')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.certificate_form">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.certificate_form"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="business_license_img">
                                        {{ $t('pos.document.business_license') }}
                                    </kt-form-label>
                                    <kt-form-label for="business_license_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="business_license_img"
                                            name="business_license_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.business_license_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('business_license_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.business_license_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.business_license_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="first_ownership_document_img">
                                        {{ $t('pos.document.first_ownership_document') }}
                                    </kt-form-label>
                                    <kt-form-label for="first_ownership_document_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="first_ownership_document_img"
                                            name="first_ownership_document_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.first_ownership_document_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('first_ownership_document_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.first_ownership_document_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.first_ownership_document_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                    </kt-row>
                    <kt-row
                            style="margin-top: 35px">
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="second_ownership_document_img">
                                        {{ $t('pos.document.second_ownership_document') }}
                                    </kt-form-label>
                                    <kt-form-label for="second_ownership_document_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="second_ownership_document_img"
                                            name="second_ownership_document_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.second_ownership_document_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('second_ownership_document_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.second_ownership_document_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.second_ownership_document_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="communicating_documents_img">
                                        {{ $t('pos.document.communicating_documents') }}
                                    </kt-form-label>
                                    <kt-form-label for="communicating_documents_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="communicating_documents_img"
                                            name="communicating_documents_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.communicating_documents_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('communicating_documents_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.communicating_documents_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.communicating_documents_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="license_granting_certificate_img">
                                        {{ $t('pos.document.license_granting_certificate') }}
                                    </kt-form-label>
                                    <kt-form-label for="license_granting_certificate_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="license_granting_certificate_img"
                                            name="license_granting_certificate_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.license_granting_certificate_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('license_granting_certificate_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.license_granting_certificate_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.license_granting_certificate_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="trust_number_img">
                                        {{ $t('pos.document.trust_number') }}
                                    </kt-form-label>
                                    <kt-form-label for="trust_number_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="trust_number_img"
                                            name="trust_number_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.trust_number_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('trust_number_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.trust_number_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.trust_number_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
            <div v-if="!this.form_data.customer_detail.customer_id"
                 class="container p-3 pt-5 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('pos.identification_documents') }}
                    </div>
                    <kt-row v-show="!form_data.customer_detail.is_foreign_nationals">
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label
                                            v-if="form_data.customer_detail.customer_type_id == customerType.REAL"
                                            for="national_card">
                                        {{ $t('pos.document.national_card') }}
                                    </kt-form-label>
                                    <kt-form-label
                                            v-if="form_data.customer_detail.customer_type_id == customerType.LEGAL"
                                            for="national_card">
                                        {{ $t('pos.document.national_card') }}{{ ' ' + $t('pos.ceo') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="national_card_img"
                                            name="national_card_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.last_newspaper_img_introduce_sh"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('last_newspaper_img_introduce_sh')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.national_card_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.national_card_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label
                                            v-if="form_data.customer_detail.customer_type_id == customerType.REAL"
                                            for="birth_certificate_card">
                                        {{ $t('pos.document.birth_certificate_card') }}
                                    </kt-form-label>
                                    <kt-form-label
                                            v-if="form_data.customer_detail.customer_type_id == customerType.LEGAL"
                                            for="national_card">
                                        {{ $t('pos.document.birth_certificate_card') }}{{ ' ' + $t('pos.ceo') }}
                                    </kt-form-label>
                                    <kt-form-label for="birth_certificate_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="birth_certificate_card_img"
                                            name="birth_certificate_card_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.birth_certificate_card_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('birth_certificate_card_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.birth_certificate_card_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.birth_certificate_card_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label
                                            v-if="form_data.customer_detail.customer_type_id == customerType.REAL"
                                            for="national_card_behind_img">
                                        {{ $t('pos.document.national_card_behind') }}
                                    </kt-form-label>
                                    <kt-form-label
                                            v-if="form_data.customer_detail.customer_type_id == customerType.LEGAL"
                                            for="national_card">
                                        {{ $t('pos.document.national_card_behind') }}{{ ' ' + $t('pos.ceo') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_behind_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="national_card_behind_img"
                                            name="national_card_behind_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.national_card_behind_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('national_card_behind_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.national_card_behind_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.national_card_behind_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                    </kt-row>
                    <kt-row v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL"
                            style="margin-top: 35px">
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="last_newspaper_img">
                                        {{ $t('pos.document.last_newspaper') }}
                                    </kt-form-label>
                                    <kt-form-label for="last_newspaper_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="last_newspaper_img"
                                            name="last_newspaper_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.last_newspaper_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('last_newspaper_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.last_newspaper_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.last_newspaper_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="statute_pages_img">
                                        {{ $t('pos.document.statute_pages') }}
                                    </kt-form-label>
                                    <kt-form-label for="statute_pages_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processStatuteFile($event)"
                                            type="file"
                                            id="statute_pages_img"
                                            name="statute_pages_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                            multiple
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="12" md="12" xs="12"
                                    v-for="(image, index) in images_url.statute_pages_img" :key="index">
                                <i v-if="images_url.statute_pages_img[index]"
                                   v-on:click="deleteStatutePages(index)" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e;margin-top: 15px;margin-right: 15px"></i>
                                 <kt-img-magnifier class="mb-4" v-if="images_url.statute_pages_img[index]"
                                     :src="image"
                                     :alt="image.alt"
                                    ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="foundation_img">
                                        {{ $t('pos.document.foundation_image') }}
                                    </kt-form-label>
                                    <kt-form-label for="foundation_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="foundation_img"
                                            name="foundation_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.foundation_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('foundation_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.foundation_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.foundation_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                    </kt-row>
                    <kt-row v-show="form_data.customer_detail.is_foreign_nationals" style="margin-top: 35px">
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="passport_img">
                                        {{ $t('pos.document.passport') }}
                                    </kt-form-label>
                                    <kt-form-label for="passport_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="passport_img"
                                            name="passport_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.passport_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('passport_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12" v-show="form_data.images_url.passport_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.passport_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="amayesh_card_img">
                                        {{ $t('pos.document.amayesh_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="amayesh_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="amyesh_card_img"
                                            name="amyesh_card_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.amyesh_card_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('amyesh_card_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.amyesh_card_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.amayesh_card_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="work_permit_img">
                                        {{ $t('pos.document.work_permit') }}
                                    </kt-form-label>
                                    <kt-form-label for="work_permit_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="work_permit_img"
                                            name="work_permit_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.work_permit_img"
                                 style="position:relative;right: 67%;top:1%;" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('work_permit_img')" class="fa fa-trash" style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.work_permit_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.work_permit_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
        </form>
        {{form_data}}
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {customerType} from '@/constants/posNovin'


export default {
    data() {
        return {
            customerType
        }
    },
    props: {
        form_data: {
            type :Object
        } ,
        is_main_merchant: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        processFile(e) {
            const name = e.target.name;
            let file = e.target.files[0];
            this.images_url[name] = URL.createObjectURL(file);
            this.form_data.documents[name] = file
        },
        processStatuteFile(e) {
            this.images_url.statute_pages_img = []
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                this.images_url.statute_pages_img[i] = URL.createObjectURL(file);
                this.form_data.documents.statute_pages_img[i] = file;
            }
        },
        deleteFile(name) {
            this.form_data.images_url[name] = '';
            this.form_data[name] = ''
        },
        deleteStatutePages(index) {
            this.$set(this.images_url.statute_pages_img, [index], '');
            this.form_data.documents.statute_pages_img[index] = ''
        },
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });

            }, 500);
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 5) {
                return this.toastr.error(i18n.t('authenticate.hint.sixth'))
            }
            return true
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }
            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    break;
                default:
                    return this.toastr.error(i18n.t('authenticate.input_format_err'))
            }
            return true
        },
    },
    mounted() {
        this.afterDispatch()
    },
    computed: {}
}
</script>
<style>
.kt-form-label {
    text-align: right !important;
}
.modal .modal-content .modal-header .close:before {
    content: ""!important;
}
.modal .modal-content .modal-body .w-100 {
    max-height: 2000px !important;
}

.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: .7;
}
</style>